var render = function render(){var _vm=this,_c=_vm._self._c;return _c('McLayoutForm',[_c('h2',[_vm._v(_vm._s(_vm.$t('general.logIn')))]),_c('LoginForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }